// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./vendor/vi-kon/laravel-admin/src/resources/assets/style/login.less
// module id = 329
// module chunks = 0